export const CM_ROW_ID_SEPARATOR = '*CM-ROW-ID-SEPARATOR*';
